import React, { useContext } from 'react'
import { HiMenuAlt2 } from 'react-icons/hi'
import { FiPlus } from 'react-icons/fi'

interface HeaderProps {
  isSidebarCollapsed: boolean
  setIsSidebarCollapsed: (value: boolean) => void
  newChat: () => void
}

const Header: React.FC<HeaderProps> = ({ isSidebarCollapsed, setIsSidebarCollapsed, newChat }) => {
  return (
    <div className="absolute top-0 bg-background md:bg-transparent z-10 py-4 w-screen md:w-60  px-4 flex items-center gap-4">
      <button
        onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        className="bg-primary text-white text-2xl p-2 rounded-lg hover:bg-[#1e3b74] hover:text-white focus:outline-none transition-colors duration-200"
        aria-label="Toggle Menu">
        <HiMenuAlt2 className="w-6 h-6" />
      </button>
      {isSidebarCollapsed && (
        <button
          onClick={() => newChat()}
          className="bg-primary text-white text-2xl p-2 rounded-lg hover:bg-[#1e3b74] hover:text-white focus:outline-none transition-colors duration-200"
          aria-label="Add Chat">
          <FiPlus className="w-6 h-6" />
        </button>
      )}
    </div>
  )
}

export default Header
